import LangEnum from '../../../../../../../../../lang/LangEnum';
import { useFindOrderConditionFreightQuotes } from '../../../../../../../../../services/modules/orderCondition/orderCondition.queries';
import { OrderConditionFreightQuote } from '../../../../../../../../../services/modules/orderCondition/orderCondition.types';
import snackbarStore from '../../../../../../../../../stores/Snackbar.store';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';
import useFreightQuoteError from '../../OrderConditionFreightField/hooks/useFreightQuoteError';

interface UseOrderConditionAutoQuoteParams {
  orderId: string;
  orderConditionId: string;
  onQuoted: () => void;
}

const hasValidQuote = (quotes?: OrderConditionFreightQuote[]) =>
  Boolean(quotes?.some((quote) => quote.validation.isValid));

const useOrderConditionAutoQuote = ({
  orderId,
  orderConditionId,
  onQuoted,
}: UseOrderConditionAutoQuoteParams) => {
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;
  const { getErrorMessage } = useFreightQuoteError();

  const quotesQuery = useFindOrderConditionFreightQuotes(
    { orderId, orderConditionId },
    { enabled: false },
  );

  const quoteAutomatically = async () => {
    const result = await quotesQuery.refetch();

    if (!result?.isSuccess) {
      handleMessage({ type: 'error', message: getErrorMessage(result?.error) });
      return;
    }

    if (!hasValidQuote(result.data)) {
      handleMessage({ type: 'error', message: getErrorMessage(null) });
      return;
    }

    handleMessage({
      type: 'success',
      message: translate(LangEnum.ORDER_CONDITION_FREIGHT_QUOTE_AVAILABLE),
    });
    onQuoted();
  };

  return { isQuoting: quotesQuery.isFetching, quoteAutomatically };
};

export default useOrderConditionAutoQuote;
